import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { SkeletonItemComponent } from './skeleton-item/skeleton-item';
//import { CalendarModule } from 'ionic3-calendar-apptoin';
@NgModule({
	declarations: [SkeletonItemComponent],
	imports: [IonicModule],
	exports: [SkeletonItemComponent,
    /*CalendarModule*/]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts